/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { yupResolver } from '@hookform/resolvers/yup';
import { Info } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Stack, Typography } from '@mui/material';
import { GatewayInfoType } from 'containers/manage/gateways/GatewaysListingType';
import _ from 'lodash';
import { FunctionComponent, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import {
  FormProvider,
  RHFSelect,
  RHFTextField,
} from '../../components/hook-form';
type Props = {
  gatewayDetails: GatewayInfoType;
  onSubmit: (data: any) => void;
  loadingUserSubmit: boolean;
  payPalKeyError: any;
};
type FormValuesProps = {
  test_client_id: string;
  payment_currency: string;
  button_layout: string;
  button_color: string;
  button_shape: string;
  button_label: string;
};

const PaypalGatewayOnboarding: FunctionComponent<Props> = ({
  gatewayDetails,
  onSubmit,
  loadingUserSubmit,
  payPalKeyError,
}) => {
  const { t } = useTranslation();

  const paymentCurrency = gatewayDetails.settings.other.filter(
    payment => payment.name === 'payment_currency'
  );

  const PaypalSchema = Yup.object().shape(
    {
      test_client_id: Yup.string().required(t('test_client_id_is_required')),
      payment_currency: Yup.string().required(
        t('payment_currency_is_required')
      ),
    },
    [['test_client_id', 'payment_currency']]
  );
  const defaultValues = {
    test_client_id:
      (gatewayDetails.user_settings?.test_client_id as string) || '',

    payment_currency:
      (gatewayDetails.user_settings.payment_currency! as string) ||
      Object.keys(paymentCurrency[0].options)[0],
  };

  const methods = useForm<FormValuesProps>({
    mode: 'all',
    resolver: yupResolver(PaypalSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setError,
    formState: { isSubmitting, errors },
  } = methods;

  useEffect(() => {
    if (!payPalKeyError.success) {
      setError('test_client_id', { message: payPalKeyError.message });
    }
  }, [payPalKeyError]);

  return (
    <>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <div className='mt-3 flex items-center text-gray-600'>
            <Info sx={{ width: '20px', height: '20px' }} />{' '}
            <span className='ml-1 text-base mt-0.5'>
              {' '}
              {t('fill_either_live_or_test_or_both')}
            </span>
          </div>
          <Typography sx={{ mt: 4, mb: 2 }} variant='h6' component='div'>
            {t('test_account_details')}:
          </Typography>
          <RHFTextField
            id='test_client_id'
            name='test_client_id'
            label={t('test_client_id')}
            sx={{ mb: '20' }}
            // error={!payPalKeyError?.success ? payPalKeyError.message : ''}
            // helperText={payPalKeyError?.message}
            error={errors?.test_client_id?.message ? true : false}
          />

          <Typography sx={{ mt: 4, mb: 2 }} variant='h6' component='div'>
            {t('other_account_details')}:
          </Typography>
          <RHFSelect
            name='payment_currency'
            label={t('payment_currency')}
            placeholder=''
          >
            {_.map(paymentCurrency[0].options, function (value, key) {
              return (
                <option key={key} value={key}>
                  {value}
                </option>
              );
            })}
          </RHFSelect>

          <LoadingButton
            fullWidth
            size='large'
            type='submit'
            variant='contained'
            aria-label='Activate Gateway'
            loading={loadingUserSubmit}
            className='!normal-case'
          >
            {t('create_form')}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </>
  );
};

export default PaypalGatewayOnboarding;
